<template>
  <div class="duty-list">
    <el-table ref="multipleTable" :data="dutyList" tooltip-effect="dark" style="width: 100%" class="common-edit-button">
      <el-table-column prop="dutyName" label="编排名称" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column prop="schoolYear" label="学年" :show-overflow-tooltip="true" width="100px">
      </el-table-column>
      <el-table-column prop="semester" label="学期" :show-overflow-tooltip="true" width="100px">
        <template slot-scope="scope">
          {{ scope.row.semester == 1 ? "上学期" : "下学期" }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" :show-overflow-tooltip="true" width="220px">
      </el-table-column>
      <!-- <el-table-column
        prop="periodList"
        label="值日时间"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{ scope.row.startDate + "~" + scope.row.endDate }}
        </template>
</el-table-column> -->
      <el-table-column label="操作" width="500px">
        <template slot-scope="scope">
          <div class="handle-container">
            <el-button type="warning" size="small" icon="el-icon-edit" @click="editDuty(scope.row)"
              v-hasPermi="'sc:duty:edit'">修改
            </el-button>
            <el-button type="success" size="small" icon="el-icon-info" @click="dutyArrangeDetail(scope.row)"
              v-hasPermi="'sc:duty:query'">编排详情
            </el-button>
            <el-button type="success" size="small" icon="el-icon-s-order" @click="dutyAllocationDetail(scope.row)"
              v-hasPermi="'sc:dutyarrange:edit'">值日详情
            </el-button>
            <el-button type="success" size="small" icon="el-icon-upload" @click="exportDutyTeacher(scope.row)">导出
            </el-button>
            <el-button type="danger" size="small" icon="el-icon-delete" @click="delDuty(scope.row)"
              v-hasPermi="'sc:duty:delete'">删除
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 修改 -->
    <editDutyDialog :editDutyShow.sync="editDutyShow" :dutyInfo="dutyInfo" :semesterOptions="semesterOptions"
      v-show="editDutyShow" />
    <!-- 编排详情 -->
    <dutyArrangeDetailDialog :dutyArrangeDetailShow.sync="dutyArrangeDetailShow" :semesterOptions="semesterOptions"
      :dutyInfo="dutyInfo" v-show="dutyArrangeDetailShow" />
    <!-- 分配详情 -->
    <dutyAllocationDetailDialog :dutyAllocationDetailShow.sync="dutyAllocationDetailShow" :dutyInfo="dutyInfo"
      v-show="dutyAllocationDetailShow" />
  </div>
</template>

<script>
import editDutyDialog from "../duty-edit/duty-edit.vue";
import dutyArrangeDetailDialog from "../duty-arrange-detail/duty-arrange-detail.vue";
import dutyAllocationDetailDialog from "../duty-allocation-detail/duty-allocation-detail.vue";
import { baseURL } from "@/api/request"; // 服务器地址

export default {
  data() {
    return {
      dutyArrangeDetailShow: false, // 编排详情
      dutyAllocationDetailShow: false, // 分配详情
      editDutyShow: false,
      dutyInfo: null,
    };
  },
  props: {
    dutyList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    semesterOptions: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  components: {
    editDutyDialog,
    dutyArrangeDetailDialog,
    dutyAllocationDetailDialog,
  },
  inject: ["refresh"],
  created() { },
  methods: {
    exportDutyTeacher(row) {
      let action = `${baseURL}${this.$url.exportDutyTeacher}?schoolId=${this.school.id}&dutyId=${row.id}`;
      window.location.href = action;
    },
    delDuty(item) {
      this.$confirm("是否删除该编排?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          this.delete(this.$url.deleteDuty + "?id=" + item.id)
            .then((res) => {
              if (res.code == 200) {
                this.$message.success("删除成功");
                // 刷新列表
                this.refresh();
              } else {
                this.$message.error("删除失败，请稍后重试");
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => { });
    },
    editDuty(item) {
      this.editDutyShow = true;
      this.dutyInfo = item;
    },
    dutyArrangeDetail(item) {
      this.dutyArrangeDetailShow = true;
      this.dutyInfo = item;
    },
    dutyAllocationDetail(item) {
      this.dutyAllocationDetailShow = true;
      this.dutyInfo = item;
    },
  },
};
</script>

<style>
@import "./dutyList.scss";
</style>
